/* Custom */
import "@/ts/utils/disable-hash-jump";

/* Lazyloading */
import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

/* Animation */
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 400, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});

/* fecha localization */
import { setGlobalDateI18n } from "fecha";

setGlobalDateI18n({
    dayNames: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
    dayNamesShort: ["Zo", "Ma", "Di", "Woe", "Do", "Vrij", "Zat"],
    monthNames: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Maa", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
});

/* Vue */
import { createApp } from "vue";
import { createPinia } from "pinia";
import SvgVue from "svg-vue3";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { i18nVue } from "laravel-vue-i18n";

import App from "./App.vue";
import StickyHeader from "./components/elements/sticky-header.vue";
import HeroCarousel from "./components/elements/hero-carousel.vue";
import SlideoutNavigation from "./components/elements/slideout-navigation.vue";
import ContactForm from "./components/contact/contact-form.vue";
import EventCalendar from "./components/events/event-calendar.vue";
import EventDetail from "./components/events/event-detail.vue";
import TextScroller from "./components/elements/text-scroller.vue";
import Spinner from "./components/elements/spinner.vue";
import MembershipWizard from "./components/members/wizard.vue";
import MembershipCancelation from "./components/members/cancel.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";

Yup.setLocale(nl);

const app = createApp(App);

app.use(SvgVue);
app.use(createPinia());
app.use(i18nVue, {
    resolve: (lang: string) => import(`../../lang/${lang}.json`),
});
app.use(VueReCaptcha, { siteKey: RECAPTCHA_SITE_KEY, loaderOptions: { autoHideBadge: true } });

app.component("StickyHeader", StickyHeader);
app.component("HeroCarousel", HeroCarousel);
app.component("SlideoutNavigation", SlideoutNavigation);
app.component("ContactForm", ContactForm);
app.component("TextScroller", TextScroller);
app.component("EventCalendar", EventCalendar);
app.component("EventDetail", EventDetail);
app.component("MembershipWizard", MembershipWizard);
app.component("MembershipCancelation", MembershipCancelation);

app.mount("#app");
